import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import QuestionSlidePreview from '../previews/QuestionSlide'
import StyledSlidePreview from '../previews/StyledSlide'
import InheritedSlide from '../previews/InheritedSlide'
import CrosstabSlide from '../previews/CrosstabSlide'

const SlideSelectModal = ({ store }) => {
    const { slideSelectModalOpen, handleCloseSlideSelectModal, handleAddSlide, addPosition } = store

    return (
        <Modal
            show={slideSelectModalOpen}
            onClose={handleCloseSlideSelectModal}
            style={{ width: 800 }}
        >
            <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                <Typography type="h3">{i18n.t('powerpoint.createSlide')}</Typography>

                <div style={{ display: 'flex', gap: 5, alignItems: 'center', padding: '5px 10px', color: '#715AF8', border: '1px solid #715AF8', backgroundColor: '#F7F5FF', borderRadius: 100 }}>
                    <i className={addPosition === 'above' ? 'far fa-arrow-up' : 'far fa-arrow-down'} style={{ fontSize: 13 }} />

                    <Typography type="tiny-b">{`Insert ${addPosition}`}</Typography>
                </div>
            </div>

            <br />

            <hr />

            <br />

            <div>
                <Typography color="grey" type="tiny-b">{i18n.t('powerpoint.sectionLayouts')}</Typography>

                <div className="pp-slide-modal-options-container">
                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('sectionHeader')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.sectionHeader')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('specification')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview includeHeader />
                        </div>

                        <Typography type="tiny">{i18n.t('powerpoint.layouts.specs')}</Typography>
                    </div>

                    {/* <div className="pp-slide-modal-option" onClick={() => handleAddSlide('swot')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview includeHeader />
                        </div>

                        <Typography type="tiny">{i18n.t('powerpoint.layouts.swot')}</Typography>
                    </div> */}

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('summary')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview includeHeader />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.summary')}</Typography>
                    </div>

                    {/* <div className="pp-slide-modal-option" onClick={() => handleAddSlide('recommendations')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview includeHeader />
                        </div>

                        <Typography type="tiny">{i18n.t('powerpoint.layouts.recommendations')}</Typography>
                    </div> */}

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('sectionSummary')}>
                        <div className="pp-slide-control-option-image">
                            <StyledSlidePreview includeHeader />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.sectionSummary')}</Typography>
                    </div>
                </div>
            </div>

            <br />

            <div>
                <Typography color="grey" type="tiny-b">{i18n.t('powerpoint.contentLayouts')}</Typography>

                <div className="pp-slide-modal-options-container">
                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('1x1')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={1} />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.1x1')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('1x2')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={2} />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.1x2')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('2x1')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={2} dir="column" />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.2x1')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('2x2')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={4} wrap />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.2x2')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('3x1')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={3} />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.3x1')}</Typography>
                    </div>
                </div>
            </div>

            <br />

            <div>
                <Typography color="grey" type="tiny-b">{i18n.t('powerpoint.advancedLayouts')}</Typography>

                <div className="pp-slide-modal-options-container">
                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('derived')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={1} typeOverride="quadrantAnalysis" />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.derived')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('crosstab')}>
                        <div className="pp-slide-control-option-image">
                            <CrosstabSlide />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.crossTab')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('inherited')}>
                        <div className="pp-slide-control-option-image">
                            <InheritedSlide />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.inherited')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('lmx')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={1} typeOverride="lmx" />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.lmx')}</Typography>
                    </div>

                    <div className="pp-slide-modal-option" onClick={() => handleAddSlide('oss')}>
                        <div className="pp-slide-control-option-image">
                            <QuestionSlidePreview count={1} typeOverride="oss" />
                        </div>

                        <Typography type="tiny-b">{i18n.t('powerpoint.layouts.oss')}</Typography>
                    </div>
                </div>

                <br />

                <div>
                    <Typography color="grey" type="tiny-b">{i18n.t('powerpoint.placeholder')}</Typography>

                    <div className="pp-slide-modal-options-container">
                        <div className="pp-slide-modal-option" onClick={() => handleAddSlide('benchmarkExplainer')}>
                            <div className="pp-slide-control-option-image">
                                <StyledSlidePreview />
                            </div>

                            <Typography type="tiny-b">{i18n.t('powerpoint.layouts.benchmarkExplainer')}</Typography>
                        </div>

                        <div className="pp-slide-modal-option" onClick={() => handleAddSlide('matrixExplainer')}>
                            <div className="pp-slide-control-option-image">
                                <QuestionSlidePreview count={1} typeOverride="lmx" />
                            </div>

                            <Typography type="tiny-b">{i18n.t('powerpoint.layouts.matrixExplainer')}</Typography>
                        </div>

                        <div className="pp-slide-modal-option" onClick={() => handleAddSlide('npsExplainer')}>
                            <div className="pp-slide-control-option-image">
                                <QuestionSlidePreview count={1} typeOverride="kpiChart" />
                            </div>

                            <Typography type="tiny-b">{i18n.t('powerpoint.layouts.npsExplainer')}</Typography>
                        </div>

                        <div className="pp-slide-modal-option" onClick={() => handleAddSlide('correlationExplainer')}>
                            <div className="pp-slide-control-option-image">
                                <QuestionSlidePreview count={1} typeOverride="quadrantAnalysis" />
                            </div>

                            <Typography type="tiny-b">{i18n.t('powerpoint.layouts.correlationExplainer')}</Typography>
                        </div>

                        <div className="pp-slide-modal-option" onClick={() => handleAddSlide('contactDetails')}>
                            <div className="pp-slide-control-option-image">
                                <StyledSlidePreview />
                            </div>

                            <Typography type="tiny-b">{i18n.t('powerpoint.layouts.contactDetails')}</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default observer(SlideSelectModal)
